<template>
  <div class="recruitment-dashboard" :class="showAdd ? 'page-hide' : ''">
    <!-- 頂部標題欄 -->
    <div class="page-title u-flex">
      <div>
        <div class="page-title-main">大學會員管理</div>
        <div class="page-title-sub">大學問總管理中心</div>
      </div>
    </div>

    <div class="era-content-grid">
      <!-- 左侧排行榜 -->
      <section class="era-ranking-section">
        <div class="era-section-header">
          <div class="era-section-title u-flex page-filter-top">
            <div class="u-flex page-filter">
              <el-select
                @change="initData"
                filterable
                clearable
                placeholder="所有地區"
                class="input-date"
                v-model="search.area"
              >
                <el-option
                  v-for="(item, index) in sys_area"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                >
                </el-option>
              </el-select>
              <!-- 账号状态（1:启用中；2：即将过期（提前一个月）;3：已过期;4:待启用） -->
              <el-select
                @change="initData"
                clearable
                placeholder="所有功能狀態"
                class="input-date"
                v-model="search.accountStatus"
              >
                <el-option label="啟用中" value="1"> </el-option>
                <el-option label="即將過期" value="2"> </el-option>
                <el-option label="已過期" value="3"> </el-option>
                <el-option label="待啟用" value="4"> </el-option>
              </el-select>
              <!-- 状态（0：正常；1:停用） -->
              <el-select
                @change="initData"
                clearable
                placeholder="帳號狀態"
                class="input-date"
                v-model="search.status"
              >
                <el-option label="有效" value="0"> </el-option>
                <el-option label="關閉" value="1"> </el-option>
              </el-select>

              <el-select
                @change="initData"
                placeholder="搜尋業務負責人"
                class="input-date"
                v-model="search.leaderId"
                clearable
              >
                <el-option
                  v-for="(item, index) in accountList"
                  :key="item.userId"
                  :label="item.nickName"
                  :value="item.userId"
                >
                </el-option>
              </el-select>
              <el-input
                clearable
                @blur="initData"
                @keyup.enter.native="initData"
                class="input-date input-date1"
                v-model="search.keyword"
                type="text"
                placeholder="搜尋會員名稱或合約編號"
              >
              </el-input>
            </div>

            <div class="title-btn" @click="toAdd()">
              <i class="el-icon-plus" style="margin-right: 0.02rem"></i>
              新增會員
            </div>
          </div>
        </div>

        <div class="era-table-container">
          <div class="ranking-table" style="margin-top: 0; min-width: 8rem">
            <!-- <div class="table-header">
							<span>會員學校</span>
							<span>會員總類</span>
							<span>合約編號</span>
							<span>會員期限</span>
							<span>業務負責人</span>
							<span>帳號狀態</span>

							<span>啟用/停用</span>
							<span>操作</span>
						</div> -->
            <div class="table-header">
              <span>會員名稱</span>
              <span>地區</span>
              <span>合約編號</span>
              <span style="min-width: 1.9rem">會員期限</span>
              <span>業務負責人</span>
              <span>帳號狀態</span>

              <span>啟用/停用</span>
              <span>操作</span>
            </div>
            <div
              class="table-row"
              v-for="(item, index) in dataList"
              :key="item.rank"
            >
              <span>{{ item.schoolName }}</span>
              <span>{{ item.area }}</span>
              <span>{{ item.contractNo }}</span>
              <span style="min-width: 1.9rem"
                >{{ item.contractStartDateFormat }}<br />{{
                  item.contractEndDateFormat
                }}</span
              >
              <span>{{ item.leaderName }}</span>
              <span>
                {{ item.accountStatus }}
              </span>
              <span
                ><el-switch
                  @change="statusChange($event, item)"
                  inactive-value="1"
                  active-value="0"
                  v-model="item.status"
                  active-color="#0BA29B"
                >
                </el-switch
              ></span>
              <span class="item-btn">
                <div class="btn btn-edit" @click="toEdit(item)">編輯</div>
                <!-- <div class="btn btn-del" @click="showApproval=true">審核</div> -->
              </span>
            </div>
          </div>
        </div>
        <div
          class="era-search u-flex"
          style="justify-content: center; margin-top: 0.2rem"
        >
          <el-pagination
            @current-change="currentChange"
            background
            layout="prev, pager, next"
            :total="dataTotal"
          >
          </el-pagination>
        </div>
      </section>

      <!-- 右侧数据面板 -->

      <div class="module-contract-add" :class="showApproval ? 'show' : ''">
        <div class="title" style="margin-top: 0.1rem">
          審核<span @click="showApproval = false"
            ><i class="el-icon-close" style="font-size: 0.3rem"></i
          ></span>
        </div>
        <div class="date-container">
          <div class="date-input-group">
            <label class="date-label">狀態</label>
            <el-select placeholder="" class="input-date" v-model="search.valu4">
              <el-option label="通過" value="1"> </el-option>
              <el-option label="拒絕" value="2"> </el-option>
            </el-select>
          </div>
          <div class="date-input-group">
            <label class="date-label">說明</label>
            <el-input
              class="input-date"
              v-model="post.value1"
              type="text"
              placeholder=""
            >
            </el-input>
          </div>
        </div>
        <div
          class="dialog-footer"
          style="margin-top: 0.2rem; text-align: right"
        >
          <el-button size="" @click="showApproval = false">取 消</el-button>
          <el-button size="" type="primary" @click="showApproval = false"
            >確定</el-button
          >
        </div>
      </div>

      <!-- 新增/编辑会员信息 -->
      <div class="dialog-fixed-right" :class="showAdd ? 'show' : ''">
        <div class="dialog-fixed-modal" v-if="showAdd"></div>
        <div class="dialog-fixed-content">
          <div class="title" style="margin-top: 0.1rem">
            {{ post.id ? "編輯" : "新增" }}會員資料<span
              @click="showAdd = false"
              ><i class="el-icon-close" style="font-size: 0.3rem"></i
            ></span>
          </div>
          <div>
            <div class="title" v-if="post.id" style="margin-top: 0.1rem">
              {{ post.schoolName }}
            </div>
            <div class="title">基本資料</div>
            <div class="date-container">
              <div class="date-input-group">
                <label class="date-label">會員學校</label>
                <el-select
                  placeholder=""
                  clearable
                  filterable
                  class="input-date"
                  v-model="post.schoolId"
                >
                  <el-option
                    v-for="(item, index) in schoolList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="date-input-group">
                <label class="date-label">會員總類</label>
                <el-select
                  clearable
                  placeholder=""
                  class="input-date"
                  v-model="post.type"
                >
                  <el-option
                    v-for="(item, index) in member_archive_type"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="date-input-group">
                <label class="date-label">地區</label>
                <el-select
                  clearable
                  placeholder=""
                  class="input-date"
                  v-model="post.area"
                >
                  <el-option
                    v-for="(item, index) in sys_area"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  >
                  </el-option>
                </el-select>
              </div>
              <template v-if="post.id">
                <!-- <div class="date-input-group">
									<label class="date-label">競爭者</label>
									<el-select clearable placeholder="" multiple class="input-date"
										v-model="post.competitors">

										<el-option v-for="(item,index) in schoolList" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>

									</el-select>
								</div> -->
                <div class="date-input-group">
                  <label class="date-label">合約起始日期</label>
                  <el-date-picker
                    disabled
                    value-format="yyyy-MM-dd"
                    class="input-date"
                    v-model="post.contractStartDate"
                    type="date"
                    placeholder=""
                  >
                  </el-date-picker>
                </div>
                <div class="date-input-group">
                  <label class="date-label">合約終止日期</label>
                  <el-date-picker
                    disabled
                    value-format="yyyy-MM-dd"
                    class="input-date"
                    v-model="post.contractEndDate"
                    type="date"
                    placeholder=""
                  >
                  </el-date-picker>
                </div>
                <div class="date-input-group">
                  <label class="date-label">狀態</label>
                  <el-select
                    placeholder=""
                    class="input-date"
                    v-model="post.status"
                  >
                    <el-option label="啟用" :value="0"> </el-option>
                    <el-option label="停用" :value="1"> </el-option>
                  </el-select>
                </div>
              </template>
            </div>

            <div class="title">聯絡資訊</div>
            <div class="date-container">
              <div class="date-input-group">
                <label class="date-label">聯絡人姓名</label>
                <el-input
                  class="input-date"
                  v-model="post.contact"
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">單位與職稱</label>
                <el-input
                  class="input-date"
                  v-model="post.post"
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">電子信箱</label>

                <el-input
                  class="input-date"
                  v-model="post.email"
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">聯絡電話</label>

                <el-input
                  class="input-date"
                  v-model="post.phone"
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">手機號碼碼</label>

                <el-input
                  class="input-date"
                  v-model="post.mobile"
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">聯絡地址</label>

                <el-input
                  class="input-date"
                  v-model="post.address"
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">第二聯絡人姓名</label>

                <el-input
                  class="input-date"
                  v-model="post.contactTwo"
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">第二聯絡人電話</label>

                <el-input
                  class="input-date"
                  v-model="post.mobileTwo"
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">第二聯絡人電子信箱</label>

                <el-input
                  class="input-date"
                  v-model="post.emailTwo"
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">業務負責人</label>
                <el-select
                  placeholder=""
                  class="input-date"
                  v-model="post.leaderId"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in accountList"
                    :key="item.userId"
                    :label="item.nickName"
                    :value="item.userId"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="date-input-group">
                <label class="date-label">備註</label>
                <el-input
                  class="input-date"
                  v-model="post.remark"
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>
            </div>
            <div class="title" v-if="post.id && showAdd == true">
              合約與帳務資訊
              <div v-if="post.id">
                <componentUserRenewal :userId="post.id"></componentUserRenewal>
              </div>
            </div>
            <div class="date-container" v-if="post.id">
              <div class="date-input-group">
                <label class="date-label">合約編號</label>
                <el-input
                  class="input-date"
                  v-model="renewalInfo.contractNo"
                  disabled
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>

              <div class="date-input-group">
                <label class="date-label">合約起始日期</label>
                <el-input
                  class="input-date"
                  v-model="renewalInfo.startDate"
                  disabled
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">合約終止日期</label>

                <el-input
                  class="input-date"
                  v-model="renewalInfo.endDate"
                  disabled
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">付款狀態</label>
                <el-input
                  class="input-date"
                  v-model="renewalInfo.payStatusDesc"
                  disabled
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>

              <div class="date-input-group">
                <label class="date-label">合約狀態</label>
                <el-input
                  class="input-date"
                  v-model="renewalInfo.statusDesc"
                  disabled
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>
              <div class="date-input-group">
                <label class="date-label">合約金額</label>
                <el-input
                  class="input-date"
                  v-model="renewalInfo.payAmount"
                  disabled
                  type="text"
                  placeholder=""
                >
                </el-input>
              </div>
            </div>
            <!-- <div class="module-role">
							<div class="title" style="margin-top: 0;">功能開通與管理</div>
							<div>
								<el-cascader placeholder="請選擇" class="input-date" :options="options" :props="props"
									collapse-tags clearable></el-cascader>
							</div>
						</div> -->
            <template v-if="post.id && showAdd">
              <componentUserAccount
                v-if="post.id"
                :userId="post.id"
              ></componentUserAccount>
            </template>
          </div>
          <div class="dialog-footer" style="margin-top: 0.2rem">
            <el-button size="" @click="showAdd = false">取 消</el-button>
            <el-button size="" type="primary" @click="sureAdd()">{{
              post.id ? "儲存" : "新增會員"
            }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import componentUserAccount from "./component-user-account.vue";
import componentUserRenewal from "./component-user-renewal.vue";
export default {
  components: {
    componentUserAccount,
    componentUserRenewal,
  },
  data() {
    return {
      page: 1,
      typeList: [],
      dataList: [],
      props: {
        multiple: true,
      },
      // 账号状态（1:启用中；2：即将过期（提前一个月）;3：已过期;4:待启用）
      accountStatusAttr: {
        1: "啟用中",
        2: "即將過期",
        3: "已過期",
        4: "待啟用",
      },
      // 付款状态（0：未付款；1：已付款；2：已取消）
      payStatusAttr: ["未付款", "已付款", "已取消"],
      // 状态（0：待审核；1:已审核；2：已驳回）
      statusAttr: ["待稽核", "已稽核", "已駁回"],
      showApproval: false,
      showContractAdd: false,
      showContractInfo: false,
      accountList: [],
      post: {
        schoolId: "",
        area: "",
        type: "",
        startDate: "",
        contact: "",
        post: "",
        email: "",
        phone: "",
        mobile: "",
        address: "",
        contactTwo: "",
        mobileTwo: "",
        emailTwo: "",
        leaderId: "",
        status: 0,
        remark: "",
      },
      schoolList: [],
      renewalInfo: {},
      sys_area: [],
      member_archive_type: [],
      dataTotal: 0,
      showAdd: false,
      search: {
        accountStatus: "",
        pageSize: 10,
      },
    };
  },
  mounted() {
    this.initData();

    this.$axios
      .post("rest-api/system/app/school/list")
      .then((res) => {
        this.schoolList = res.data;
      })
      .catch((err) => {});

    this.$axios
      .post("rest-api/system/app/common/dict-data/list", {
        dictType: "member_archive_type",
      })
      .then((res) => {
        this.member_archive_type = res.data;
      });
    this.$axios
      .post("rest-api/system/app/common/dict-data/list", {
        dictType: "sys_area",
      })
      .then((res) => {
        this.sys_area = res.data;
      });

    this.$axios
      .post("rest-api/system/app/user/list")
      .then((res) => {
        this.accountList = res.data;
      })
      .catch((err) => {});
  },
  methods: {
    getRenewal(id) {
      const that = this;
      that.renewalInfo = {};
      that.$axios
        .post("rest-api/member/app/renewal/page", {
          pageNum: 1,
          pageSize: 1,
          archiveId: id,
        })
        .then((res) => {
          if (res.data && res.data.list.length > 0) {
            let info = res.data.list[0];
            this.renewalInfo = res.data.list[0];
            this.renewalInfo.startDate = info.startDate.split(" ")[0];
            this.renewalInfo.payStatusDesc = this.payStatusAttr[info.payStatus];
            this.renewalInfo.statusDesc = this.statusAttr[info.status];
          }
        })
        .catch((err) => {});
    },
    toDel(idx) {
      this.$confirm("此操作將永久刪除該數據，是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("rest-api/member/app/archive/delete", {
              id: this.dataList[idx].id,
            })
            .then((res) => {
              this.$message({
                message: "刪除成功",
                type: "success",
              });
              this.initData();
            })
            .catch((err) => {});
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    statusChange(e, item) {
      this.post = JSON.parse(JSON.stringify(item));
      this.post.status = e;
      this.sureAdd();
    },
    sureAdd() {
      const that = this;

      if (that.post.competitors) {
        that.post.competitors = String(that.post.competitors);
      }
      if (that.post.id) {
        that.$axios
          .post("rest-api/member/app/archive/edit", that.post)
          .then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.showAdd = false;
            this.initData();
          })
          .catch((err) => {});
      } else {
        that.$axios
          .post("rest-api/member/app/archive/add", that.post)
          .then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.showAdd = false;
            this.initData();
          })
          .catch((err) => {});
      }
    },
    toEdit(item) {
      this.$axios
        .post("rest-api/member/app/archive/detail", {
          id: item.id,
        })
        .then((res) => {
          this.post = JSON.parse(JSON.stringify(res.data));
          this.post.status = Number(res.data.status);
          this.post.competitors = [];
          if (res.data.competitorList) {
            this.post.competitors = res.data.competitorList;
          }
          this.getRenewal(item.id);
          this.showAdd = true;
        })
        .catch((err) => {});
    },
    toAdd() {
      this.showAdd = true;
      this.post = {
        schoolId: "",
        area: "",
        type: "",
        startDate: "",
        contact: "",
        post: "",
        email: "",
        phone: "",
        mobile: "",
        address: "",
        contactTwo: "",
        mobileTwo: "",
        emailTwo: "",
        leaderId: "",
        status: 0,
        remark: "",
      };
    },
    currentChange(e) {
      this.page = e;
      this.getList();
    },
    initData() {
      this.page = 1;
      this.getList();
    },
    getList() {
      const that = this;
      that.$axios
        .post("rest-api/member/app/archive/page", {
          pageNum: that.page,
          ...that.search,
        })
        .then((res) => {
          that.dataList = res.data.list;
          that.dataTotal = res.data.total;
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped lang="scss">
.recruitment-dashboard {
  min-height: 100vh;
  background: #eef3f6;
  padding: 0.2rem;
}

/* 頂部標題欄 */
.dashboard-header {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
  margin-bottom: 0.2rem;
  box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-title {
}

.help-btn {
  background: #4a5568;
  color: white;
  border: none;
  padding: 0.08rem 0.2rem;
  border-radius: 0.06rem;
  font-size: 0.2rem;
  cursor: pointer;
}

/* 日期選擇區域 */
.date-section {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
  margin-bottom: 0.2rem;
}

.date-container {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
}

.date-input-group {
  width: 32%;
  min-width: 32%;
  margin-right: 1.2%;
  margin-bottom: 0.2rem;
}

.date-label {
  display: flex;
  align-items: center;
  margin-bottom: 0.08rem;
  color: #222;
  font-size: 0.18rem;
}

.date-input {
  background: #91a2a41a;
  border: 0.01rem solid #91a2a480;
  border-radius: 0.08rem;
  font-size: 0.2rem;
  padding: 0.12rem 0.1rem;
  color: #999;
}

/* 核心數據指標 */
.kpi-section {
  flex: 1;
  margin-right: 0.1rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
}

.section-title {
  font-weight: bold;
  font-size: 0.2rem;
  margin-bottom: 0.2rem;
  color: #2d3748;
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(1.8rem, 1fr));
  gap: 0.2rem;
}

.kpi-card {
  background: white;
  position: relative;
  border-radius: 0.12rem;
  padding: 0.25rem;
  box-shadow: 0.04rem 0.04rem 0.2rem 0rem #27545726;

  .ic-block {
    width: 0.5rem;
    height: 0.5rem;
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
  }
}

.kpi-header {
  margin-bottom: 00.17rem;
}

.kpi-name {
  font-size: 0.18rem;
  color: #777;
}

.kpi-value {
  font-size: 0.32rem;
  color: #000;
  margin-bottom: 0.4rem;
}

.kpi-comparison {
  display: flex;
  align-items: center;
  gap: 0.06rem;
  font-size: 0.12rem;
}

.kpi-comparison.positive {
  color: #21c93a;
}

.trend-icon {
  font-weight: bold;
}

/* 主要內容區域 */
.main-content {
  flex: 1;
  margin-left: 0.1rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.12rem;
  padding: 0.2rem;
}

.content-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 0.3rem;
}

/* 排行榜樣式 */
.ranking-section {
  flex: 1;
  margin-left: 0.1rem;
  background: white;
  border-radius: 0.12rem;
  padding: 0.2rem;
  box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.05);
}

.ranking-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.1rem;
}

.ranking-title {
  font-size: 0.2rem;
  font-weight: bold;
  color: #2d3748;
  margin-bottom: 0.2rem;
}

.ranking-table {
  border: 0.01rem solid #27545726;
  border-radius: 0.1rem;
  margin-top: 0.2rem;
  overflow: hidden;
}

.ranking-date {
  color: #718096;
  font-size: 0.2rem;
}

.ranking-subtitle {
  color: #718096;
  font-size: 0.2rem;
  margin-bottom: 0.2rem;
}

.table-header {
  display: flex;
  padding: 0.12rem 0;
  border-bottom: 0.01rem solid #e2e8f0;
  background: #0ba29b0f;
  color: #4a5568;
  font-size: 0.18rem;
}

.table-header span {
  flex: 1;
  text-align: center;
}

.table-row span {
  flex: 1;
  word-break: break-all;
  text-align: center;
}

.table-row {
  display: flex;
  padding: 0.12rem 0;
  font-size: 0.18rem;
  border-bottom: 0.01rem solid #e2e8f0;
}

.rank {
  color: #4a5568;
}

.department {
  color: #2d3748;
}

.area,
.rate {
  text-align: right;
  color: #4a5568;
}

/* 篩選區域樣式 */
.filter-section {
  background: white;
  border-radius: 0.12rem;
  padding: 0.2rem;
  box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.05);
}

.filter-group {
  display: flex;
  gap: 0.1rem;
  margin-bottom: 0.2rem;
}

.filter-btn {
  flex: 1;
  padding: 0.1rem;
  border: 0.01rem solid #e2e8f0;
  background: #f7fafc;
  border-radius: 0.08rem;
  cursor: pointer;
  transition: all 0.3s;
}

.filter-btn.active {
  background: #667eea;
  color: white;
  border-color: #667eea;
}

.primary-btn {
  width: 100%;
  padding: 0.12rem;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 0.08rem;
  font-size: 0.2rem;
  cursor: pointer;
  margin-bottom: 0.2rem;
}

.dropdown {
  width: 100%;
  padding: 0.12rem;
  border: 0.01rem solid #e2e8f0;
  border-radius: 0.08rem;
  background: white;
  margin-bottom: 0.2rem;
}

.stats-info {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.stat-item {
  padding: 0.1rem;
  background: #f7fafc;
  border-radius: 0.06rem;
  text-align: center;
  color: #718096;
  font-size: 0.2rem;
}

/* 響應式設計 */
@media (max-width: 1024px) {
  .content-grid {
    grid-template-columns: 1fr;
    gap: 0.2rem;
  }
}

@media (max-width: 768px) {
  .recruitment-dashboard {
    padding: 0.1rem;
  }

  .header-content {
    flex-direction: column;
    gap: 00.17rem;
    align-items: flex-start;
  }

  .date-container {
    flex-direction: column;
    gap: 00.17rem;
  }

  .kpi-grid {
    grid-template-columns: 1fr;
  }

  .table-header,
  .table-row {
    grid-template-columns: 0.5rem 1fr 0.8rem 0.7rem;
    gap: 0.1rem;
    font-size: 0.2rem;
  }

  .filter-group {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .kpi-value {
    font-size: 0.24rem;
  }

  .table-header,
  .table-row {
    grid-template-columns: 0.4rem 1fr 0.7rem 0.6rem;
    gap: 0.08rem;
  }

  .ranking-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.1rem;
  }
}

.search-title {
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-bottom: 0.28rem;
}

.modle-block2 {
  display: flex;
}

@media (max-width: 1024px) {
  .modle-block2 {
    display: block;
  }

  .kpi-section {
    margin-right: 0;
  }

  .ranking-section {
    margin-left: 0;
  }
}

/* 页面标题 */
.era-header {
  margin-bottom: 0.3rem;
}

.era-main-title {
  font-size: 0.28rem;
  font-weight: 700;
  color: #2d3748;
  text-align: center;
}

/* 内容网格布局 */
.era-content-grid {
  display: grid;
  // grid-template-columns: 2fr 1fr;
  gap: 0.3rem;
  margin: 0 auto;
}

/* 排行榜区域 */
.era-ranking-section {
}

.era-section-header {
  margin: 0 0 0.2rem;
}

.era-section-title {
  font-weight: bold;
  color: #2d3748;
  justify-content: space-between;

  .title-btn {
    background: #0ba29b;
    padding: 0.12rem;
    border-radius: 0.06rem;
    color: #fff;
    cursor: pointer;
    font-size: 0.2rem;
  }

  .tips {
    font-weight: normal;
    font-size: 0.12rem;
    color: #ed6d00;
    margin-left: 0.3rem;
  }

  img {
    width: 0.2rem;
    height: 0.2rem;
    margin-right: 0.06rem;
  }
}

.era-section-title-sub {
  font-size: 00.17rem;
  font-weight: bold;
  color: #0ba29b;
  margin-bottom: 0.2rem;
  margin-top: 0.2rem;
}

/* 表格样式 */
.era-table-container {
  overflow-x: auto;
}

.era-ranking-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.2rem;
}

.era-ranking-table th {
  background: #f8fafc;
  padding: 0.12rem 0.08rem;
  text-align: left;
  font-weight: bold;
  color: #4a5568;
  border-bottom: 0.02rem solid #e2e8f0;
}

.era-ranking-table td {
  padding: 0.12rem 0.08rem;
  border-bottom: 0.01rem solid #e2e8f0;
  color: #4a5568;
}

.era-ranking-table .era-highlight-row {
  background: #fffaf0;
}

.era-ranking-table .era-highlight-row td {
  font-weight: 500;
}

.era-rank-col {
  width: 0.6rem;
}

.era-name-col {
  min-width: 2rem;
}

.era-private-col {
  width: 1.2rem;
}

.era-growth-col {
  width: 1rem;
}

.era-school-col {
  width: 1.4rem;
}

.era-rank-cell {
  text-align: center;
}

.era-rank-number {
  display: inline-block;
  width: 0.28rem;
  height: 0.28rem;
  line-height: 0.28rem;
  text-align: center;
  background: #667eea;
  color: white;
  border-radius: 50%;
  font-size: 0.12rem;
  font-weight: bold;
}

.era-ranking-table .era-highlight-row .era-rank-number {
  background: #ed8936;
}

.era-name-cell {
  color: #2d3748;
  font-weight: 500;
}

.era-growth-cell {
  text-align: center;
}

.era-growth-rate.era-positive {
  color: #48bb78;
  font-weight: bold;
}

.era-school-cell {
  text-align: right;
}

/* 右侧数据面板 */
.era-stats-panel {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-top: 0.4rem;
}

.era-chart-section,
.era-quality-section {
  background: #eef6f685;
  border-radius: 00.17rem;
  padding: 0 00.17rem 00.17rem;
}

.era-chart-title {
  font-size: 0.2rem;
  font-weight: bold;
  color: #2d3748;
  margin-bottom: 0.2rem;
}

/* 管道列表 */
.era-channel-list {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.era-channel-item {
  display: flex;
  align-items: center;
  gap: 0.1rem;
  padding: 0.08rem 0;
}

.era-channel-dot {
  width: 0.12rem;
  height: 0.12rem;
  border-radius: 50%;
}

.era-channel-dot.era-organic {
  background: #48bb78;
}

.era-channel-dot.era-referral {
  background: #ed8936;
}

.era-channel-dot.era-social {
  background: #9f7aea;
}

.era-channel-dot.era-paid {
  background: #4299e1;
}

.era-channel-dot.era-direct {
  background: #f56565;
}

.era-channel-name {
  color: #4a5568;
  font-size: 0.2rem;
}

/* 品质评比表格 */
.era-quality-table {
  display: flex;
  flex-direction: column;
  gap: 00.17rem;
}

.era-table-header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 00.17rem;
  padding-bottom: 0.1rem;
  border-bottom: 0.02rem solid #e2e8f0;
  font-weight: bold;
  color: #4a5568;
  font-size: 0.12rem;
}

.era-table-body {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
}

.era-table-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 00.17rem;
  align-items: center;
}

.era-channel-cell {
  font-size: 0.12rem;
  color: #4a5568;
  font-weight: 500;
}

.era-progress-cell {
  position: relative;
}

.era-progress-bar {
  position: relative;
  height: 0.24rem;
  background: #f7fafc;
  border-radius: 0.12rem;
  overflow: hidden;
}

.era-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea, #764ba2);
  border-radius: 0.12rem;
  transition: width 0.3s ease;
}

.era-progress-fill.era-depth-fill {
  background: linear-gradient(90deg, #48bb78, #38a169);
}

.era-progress-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.11rem;
  font-weight: bold;
  color: #2d3748;
  z-index: 1;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .era-content-grid {
    grid-template-columns: 1fr;
    gap: 0.2rem;
  }

  .era-stats-panel {
    flex-direction: row;
  }

  .era-stats-panel {
    padding-top: 0;
  }

  .era-chart-section,
  .era-quality-section {
    flex: 1;
  }

  .page-title {
    display: block;

    .page-title-btn {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
    }
  }
}

@media (max-width: 768px) {
  .date-input-group {
    width: 100%;
    min-width: 100%;
    margin: 0;
  }

  .dialog-account {
    width: 90% !important;
  }

  .era-container {
    padding: 00.17rem;
  }

  .era-section-title {
    .tips {
      margin-left: 0;
      margin-top: 00.17rem;
    }
  }

  .era-main-title {
    font-size: 0.22rem;
  }

  .era-content-grid {
    gap: 00.17rem;
  }

  .era-stats-panel {
    flex-direction: column;
  }

  .era-ranking-table {
    font-size: 0.12rem;
  }

  .era-ranking-table th,
  .era-ranking-table td {
    padding: 0.08rem 0.06rem;
  }

  .era-name-col {
    min-width: 1.5rem;
  }

  .era-private-col {
    width: 1rem;
  }

  .era-growth-col {
    width: 0.8rem;
  }

  .era-school-col {
    width: 1.2rem;
  }
}

@media (max-width: 480px) {
  .era-container {
    padding: 0.1rem;
  }

  .era-main-title {
    font-size: 0.2rem;
  }

  .era-ranking-table {
    font-size: 0.11rem;
  }

  .era-ranking-table th,
  .era-ranking-table td {
    padding: 0.06rem 0.04rem;
  }

  .era-table-header,
  .era-table-row {
    grid-template-columns: 1fr 1fr;
    gap: 0.1rem;
  }

  .era-table-header .era-depth-header,
  .era-table-row .era-progress-cell:last-child {
    display: none;
  }

  .era-rank-number {
    width: 0.24rem;
    height: 0.24rem;
    line-height: 0.24rem;
    font-size: 0.11rem;
  }
}

.era-content-grid {
  margin-top: 0.2rem;
  background: white;
  border-radius: 0.12rem;
  padding: 0.2rem;
  box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.08);
}

.page-title {
  justify-content: space-between;
  margin: 0 0 0.3rem;

  .page-title-main {
    font-size: 0.26rem;
    font-weight: bold;
  }

  .page-title-sub {
    color: #0ba29b;
    font-size: 0.22rem;
    font-weight: bold;
    margin-top: 0.12rem;
  }
}

.module-show {
  background: #ed6d001a;
  color: #ed6d00;
  font: size 0.2rem;
  padding: 0.2rem;
  margin-top: 0.3rem;
}

.tips1 {
  background: #ed6d001a;
  border-radius: 16px;
  font-size: 0.12rem;
  color: #ed6d00;
  padding: 0.08rem 0.2rem;
}

.item-btn {
  display: flex;
  justify-content: center;

  .btn {
    cursor: pointer;
    padding: 0 0.05rem;
  }

  .btn-edit {
    color: #0ba29b;
  }

  .btn-del {
    color: #ff383c;
  }
}

.module-count {
  background: #f3f3f3;
  border: 1px dashed #275457;
  border-radius: 10px;
  padding: 0.3rem 0.24rem;

  .module-header {
    justify-content: space-between;
    font-weight: bold;
    margin-bottom: 0.2rem;
  }
}

.btn-add {
  background: #0ba29b;
  padding: 0.12rem;
  border-radius: 0.06rem;
  color: #fff;
  font-size: 0.2rem;
  margin-top: 0.2rem;
}

.input-tips {
  font-size: 0.12rem;
  color: #999;
}

.title {
  font-size: 0.2rem;
  color: #222;
  margin-top: 0.24rem;
  margin-bottom: 0.24rem;
  display: flex;
  justify-content: space-between;
}

.dialog-account {
  width: 8rem;
  margin: 0 auto;

  ::v-deep .el-dialog {
    width: 100% !important;
    overflow: auto;
  }
}

.module-role {
  border-top: 1px dashed #e1e1e1;
  padding-top: 0.3rem;
  margin-top: 0.3rem;
}

.module-contract-add {
  position: fixed;
  top: 0;
  right: -100%;
  opacity: 0;
  transition: 0.5s ease-in-out;
  width: 30%;
  z-index: 100;
  bottom: 0;
  display: block;
  background-color: #f7f8fc;
  padding: 0.2rem;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.2);
}

.module-contract-add .date-input-group {
  width: 100%;
  min-width: 100%;
  margin: 0 0 0.2rem;
}

.module-contract-add.show {
  opacity: 1;
  right: 0;
}

.contract-list {
  .item {
    margin-bottom: 0.24rem;
  }

  .item-date {
    font-size: 0.14rem;
    font-weight: bold;
  }

  .item-content {
    border: 1px solid #949baa4d;
    border-radius: 5px;
    padding: 0.06rem 0.12rem;
    margin-top: 0.1rem;
  }

  .item-show {
    font-size: 0.14rem;
    display: flex;
    justify-content: space-between;
    padding: 0.06rem;
  }
}

@media (max-width: 1024px) {
  .module-contract-add {
    width: 90%;
  }

  .module-contract-add .date-input-group {
    margin: 0;
  }
}
</style>
